class PathFinderResult {
    found = false
    paths = []

    constructor (found, paths) {
        this.found = found
        this.paths = paths
    }
}

class PathFinder {
    _maxResults
    _object

    static COMPARATORS = {
        keyHasCommonLettersWithInput: (key, input) => {
            if (typeof key !== 'string' || typeof input !== 'string') return false
            return key.trim().toLowerCase().replace(/\s+/g, ' ').includes(input.trim().toLowerCase().replace(/\s+/g, ' '));
        }
    }

    constructor (object, maxResults) {
        this._maxResults = maxResults || 10
        this._object = object
    }

    findPathsTo (name, compare = PathFinder.COMPARATORS.keyHasCommonLettersWithInput,
        object = this._object, currentPath = [], resultingPaths = []) {

        if (typeof object !== 'object') return

        for (const key in object) {
            if (resultingPaths.length === this._maxResults) break
            if (compare(key, name)) {
                const resultingPath = [...currentPath, key]
                resultingPath.exhausted = object[key] == null
                resultingPaths.push(resultingPath)
            }
            this.findPathsTo(name, compare,
                object[key], [...currentPath, key], resultingPaths)
        }

        return new PathFinderResult(Boolean(resultingPaths.length), resultingPaths)
    }

    pathExhausted (path, object) {
        if (!Array.isArray(path) || path.length < 1 || !object) return null
        return object[path[path.length - 1]] == null
    }
}

export default PathFinder